<template>
    <div v-if="error" class="text-danger mb-2">
                    {{ error }}
    </div>
    <div v-if="message" class="container-fluid" >
        <div class="alert alert-secondary" role="alert">
            {{ message }}
        </div>        
    </div>
    <div class="row mx-3" v-if="selectedSandbox || selectedBucket || selectedCredential" :class="dropDownDisable?'dropDownMenu':''">
        <div v-if="sandboxOptions.length>0 || dropDownLoading=='sandbox'" class="col-md-6 col-lg-3 mb-2">
            <label class="form-label">Choose a Sandbox <span class="text-danger">&nbsp;*</span></label>
            
            <select  v-if="selectedSandbox" class="form-select form-control"  v-model="selectedSandbox">
                    <option  v-for="option in sandboxOptions" :key="option.index" :value="option.value">
                        {{ option.label }}
                    </option>
            </select>
            <div v-else class="spinner-border spinner-border-sm loader">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div  v-if="credentialOptions.length>0 || dropDownLoading=='credential'" class="col-md-6 col-lg-3 mb-2">
            <label class="form-label">Choose a Credential <span class="text-danger">&nbsp;*</span></label>
            <select v-if="credentialOptions.length>0" class="form-select form-control" @change="selectedCredential=$event.target.value" v-model="selectedCredential">
                    <option v-for="option in credentialOptions" :key="option.index" :value="option.value">
                        {{ option.label }}
                    </option>
            </select>
            <div v-else 
                class="spinner-border spinner-border-sm loader">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div  v-if="bucketOptions.length>0 || dropDownLoading=='bucket'" class="col-md-6 col-lg-3 mb-2">
            <label class="form-label">Choose a bucket <span class="text-danger">&nbsp;*</span></label>
            <select v-if ="bucketOptions.length>0" class="form-select form-control" @change="onSelectBucket($event.target.value)" v-model="selectedBucket">
                    <option v-for="option in bucketOptions" :key="option.index" :value="option.value">
                        {{ option.label }}
                    </option>
            </select>
            <div  v-else class="spinner-border spinner-border-sm loader ">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div> 
        <div v-if="selectedCredential" class="col text-end" > 
            <button style="margin-top: 28px" :disabled="loading" type="button" @click="onRefresh()" class="btn lift btn-primary float-right" ><i class="fa fa-refresh"/></button>
        </div>
    </div>
    <div v-if="selectedBucket" class="mx-4 my-3">
        <Breadcrumbs :breadcrumbItems="this.$store.state.breadcrumbs" :key="this.$store.state.breadcrumbs.length" :showRoute="false" @onBreadcrumbClick="onBreadcrumbClick"/>
        <FolderView 
            tableId="fileBrowserTable"
            :data="filesList" baseUrl=''
            :loading="loading" 
            name='File Browser Folder'
            identifier='folderName' icon='folder'
            @fetchSubFolder = "fetchSubFolder"
            @selectedFiles="selectedFiles"/> 

    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FolderView from "../../components/FolderView.vue";
import Breadcrumbs from "../../components/Breadcrumbs.vue";

export default {
    components: { FolderView ,Breadcrumbs},
    data() {
        return {
            bucketList:[],
            filesList: [],
            credentialList:[],
            loading: true,
            dropDownLoading: '',
            selectedSandbox : null,
            selectedBucket: null,
            selectedCredential:null,
            error :null,
            message: null,
            subFolderId: null,
            presignURL: null
        };
    },
    props: {
        generateURL: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            devSandboxes: (state) => state.sandbox.devSandboxes,
            folderPath: (state) => state.amdp.folderPath,
        }),
        sandboxOptions(){
            return this.devSandboxes? this.devSandboxes.map((sandbox) => {
                return {"label": sandbox.name, "value": sandbox.name };                
            }) : [];
            
        },
        credentialOptions(){
            if(this.credentialList && this.credentialList.length >0){
                return this.credentialList.map((credential)=>{
                    return {label: credential.sandbox_credential_name, value: credential.sandbox_credential_name}
                })
            }
            return []
        },
        bucketOptions(){
            if(this.bucketList && this.bucketList.length >0){
                return this.bucketList.map((bucket)=>{
                    return {label: bucket.name, value: bucket.name}
                })
            }
            return []
        },
        folderPath(){
           return this.$store.state.amdp.folderPath;
        },
        dropDownDisable(){
            return this.dropDownLoading !=''
        }      
    },
    watch: {
        devSandboxes(newValue){
            if(newValue != this.devSandboxes)
            this.setInitialSelectSandbox();
        },
        async selectedSandbox(newSandboxName){
            // emit selected sandbox for output parser in MMD/GMD
            this.$emit('onSandboxChange', newSandboxName);

            this.dropDownLoading="credential"
            this.message=null;
            this.error= null;
            this.selectedCredential='';
            this.selectedBucket=''
            this.$store.dispatch('setBreadcrumbs',[])  
            this.bucketList =[]
            if(newSandboxName && newSandboxName != ""){
                this.$store.dispatch("sandbox/setCurrentSandbox", newSandboxName);
                let response = await this.getSandboxCredentials(newSandboxName);
                if(!response.data){
                    this.message=`There is no credential for sandbox ${this.selectedSandbox}`
                    this.dropDownLoading=''
                    this.credentialList=[]
                }
                if(response.data && response.data.length>0){ 
                    this.credentialList= response.data.filter((cred)=>cred.type=="aws")
                }
            }else{
                this.message ="No Sandboxes available!"
            }
            this.loading = false
        },
        async selectedCredential(newValue){
            if(newValue && newValue != ""){
                this.dropDownLoading="bucket";
                this.message=null;
                this.error= null;
                this.selectedBucket='';
                this.$store.dispatch('setBreadcrumbs',[])  
                this.bucketList =[]
                this.$store.dispatch('amdp/setSelectedCredential',newValue)
                await this.fetchBucketList() 
            }
        },
        selectedBucket(to, from){
            if ((( !from && !to ) ||(from !==to))) {  
                this.setFolderPathAndFetchFielList();                
            }
        },
        filesList() {
            this.filesList.map((file) => {
                file['folderName'] = file.name.replace("/", '')
            });
        } 
    },
    methods: {
        ...mapActions({
            getBucketList: "amdp/getBucketList",
            getSandboxCredentials: "amdp/getSandboxCredentials",  
            getFileBrowserList: "amdp/getFileBrowserList",
            getPresignURL: "amdp/getPresignURL",
        }),
        setInitialSelectSandbox() {
            const defaultSandboxRegex = /(c\d\d\d-dev)$/g
                if(!this.sandboxOptions.length) {
                    this.selectedSandbox = null;
                } else {
                    const filteredSandboxList = this.sandboxOptions.filter((e) => {
                        return e.value.match(defaultSandboxRegex);                    
                    })
                    this.selectedSandbox =  (filteredSandboxList.length)?filteredSandboxList[0].value:this.sandboxOptions[0].value;
                    this.$store.dispatch("sandbox/setCurrentSandbox", this.selectedSandbox);
                } 
        },
        fetchSubFolder(subFolderId) {
            this.setFolderPathAndFetchFielList(subFolderId);
        },
        setFolderPathAndFetchFielList(subFolderId) {
            let path =this.folderPath
            let refresh =false;
            if (path === "" || path.endsWith("@")|| path.endsWith("@/") || !subFolderId){
                let credential=this.$store.state.amdp.selectedCredential
                //setting credential in path
                path ="s3://"+(credential?this.$store.state.currentClient.cid+'.'+credential+'@':'')+this.selectedBucket+"/"+("")
                refresh= true
            }
            else if(subFolderId){
                path =path+subFolderId +"/"
                refresh= true
            }
            if(refresh){
                this.$store.dispatch('amdp/setFolderPath',path.replace("slash/","/").replace("///","//")); 
                this.filesList=[]
                this.fetchFileBrowserList(this.folderPath)
            }  
        },
        selectedFiles(selectedFile) {
            if(selectedFile) {
                if (selectedFile.is_dir === "false" ) {
                    const s3Path = this.buildS3Path(selectedFile.name);
                    // Emit file clicked event before starting presigned URL fetch
                    this.$emit('onFileClicked', {name: s3Path});
                    if(this.generateURL || selectedFile.name.endsWith('.json') || selectedFile.name.endsWith('.csv') ){
                        this.fetchPresignURL(s3Path);
                    }else{
                        this.$emit('onFileSelect', {presignedUrl:null, name:s3Path});
                    }
                }
            }
        },
        async fetchBucketList(refresh=false){
            let response;
            this.loading=true;
            this.error=null;
            if(refresh){
               this.dropDownLoading= 'bucket'
            }
            try {
                let param ={
                    credential:this.$route.params.cid+"."+this.selectedCredential,
                    type:"s3",
                    sandboxName:this.selectedSandbox
                }
                response = await this.getBucketList(param);
            } catch (error) {
                if (error.response.data.error) this.error = error.response.data.error;
                else this.error = error.message;
                this.dropDownLoading=''
                this.$store.dispatch('setBreadcrumbs',[]) 
                this.loading = false;
                return;
            }
            this.bucketList = await response.data? response.data :[];
            if(!this.bucketList){
                this.selectedBucket =""
                this.$store.dispatch('setBreadcrumbs',[])  
                this.message=`There is no bucket for sandbox ${this.selectedSandbox} and credential ${this.selectedCredential}`
            }
            this.dropDownLoading=''
            this.loading = false
        },
        onSelectBucket(bucket){
            let breadcrumbPath=[{
                name:bucket,
                route:{
                    name: "File Browser List",
                    params: {
                                bucket: `${bucket}`,
                                cid:this.$store.state.currentClient.cid,
                                sandboxId:this.selectedSandbox
                            }
                    }
            }]
            //Showing the bucket folders
            this.$store.dispatch('setBreadcrumbs',breadcrumbPath)
            // Only reset folder path if bucket actually changed
            if (this.selectedBucket !== bucket) {
                this.$store.dispatch('amdp/setFolderPath',"");
            }
            
           
        },
        async fetchFileBrowserList(folderPath) {
            this.error = null;
            this.filesList = [];
            this.loading = true;
           
            if ((folderPath && folderPath !== "s3://")) {
                let response;
                try {
                    response = await this.getFileBrowserList({folderName: folderPath, sandboxName:this.selectedSandbox});
                } catch (error) {
                    this.filesList=[]
                    this.loading = false
                    if (error.response.data.error) this.error = error.response.data.error;
                    else this.error = error.message;
                    return;
                }
                this.filesList = await response.data? response.data :[];       
            }
            this.loading = false;
        },
        onRefresh(){
            if(this.selectedBucket){
                this.filesList=[]
                this.fetchFileBrowserList(this.folderPath)
            }else{
                this.dropDownLoading='bucket';
                this.bucketList=[];
                this.fetchBucketList(true)  
            }
        },
        buildS3Path(fileName) {
            const currentFolderPath = this.$store.state.amdp.folderPath;
            if (currentFolderPath && currentFolderPath !== "s3://") {
                return currentFolderPath + fileName;
            } else {
                const selectedBucket = this.selectedBucket;
                const selectedCredential = this.$store.state.amdp.selectedCredential;
                const cid = this.$store.state.currentClient?.cid;
                
                if (selectedBucket) {
                    let path = "s3://";
                    if (selectedCredential && cid) {
                        path += `${cid}.${selectedCredential}@`;
                    }
                    path += `${selectedBucket}/${fileName}`;
                    return path;
                }
            }
            return fileName;
        },
        async fetchPresignURL(S3Path) { 
            this.loading = true;
            let response;
            try {
                response = await this.getPresignURL({filePath:S3Path, operation:"download", sandboxName: this.selectedSandbox },);
            } catch (error) {
                this.loading=false
                if (error.response.data.error) this.error = error.response.data.error;
                else this.error = error.message;
                return;
            }
            let data = await response.data
            this.presignURL =  data.url;
            this.$emit('onFileSelect', {presignedUrl:this.presignURL, name:S3Path, sandbox: this.selectedSandbox});
            this.loading = false
        },
        onBreadcrumbClick(){
            this.fetchFileBrowserList(this.folderPath)
        }
    },
    mounted() {
        this.setInitialSelectSandbox();
    },
    emits: ['onFileSelect', 'onFileClicked', 'onSandboxChange']

}
</script>

<style>

</style>